import BaseLayouter from 'bpmn-js/lib/features/modeling/BpmnLayouter';
import { is } from 'bpmn-js/lib/util/ModelUtil';
import { getMid } from 'diagram-js/lib/layout/LayoutUtil';
import { assign } from 'min-dash';
import { repairConnection, withoutRedundantPoints } from 'diagram-js/lib/layout/ManhattanLayout';

export class PathwaysLayoutHandler extends BaseLayouter {
  constructor(private isVertical) {
    super();
  }

  private getConnectionDocking(point, shape) {
    return point ? (point.original || point) : getMid(shape);
  }

  layoutConnection(connection, hints) {
    hints = hints || {};

    let source = connection.source,
      target = connection.target,
      waypoints = connection.waypoints,
      start = hints.connectionStart,
      end = hints.connectionEnd;

    // Only change bpmn:SequenceFlow waypoints calculations
    if (!this.isVertical || !is(connection, 'bpmn:SequenceFlow') || is(source, 'bpmn:BoundaryEvent') || source === target) {
      return super.layoutConnection(connection, hints);
    }

    let manhattanOptions,
      updatedWaypoints;

    if (!start) {
      start = this.getConnectionDocking(waypoints && waypoints[0], source);
    }

    if (!end) {
      end = this.getConnectionDocking(waypoints && waypoints[waypoints.length - 1], target);
    }

    if (is(source, 'bpmn:Gateway')) {
      manhattanOptions = {
        preferredLayouts: ['h:v']
      };
    } else if (is(target, 'bpmn:Gateway')) {
      manhattanOptions = {
        preferredLayouts: ['v:h']
      };
    } else {
      manhattanOptions = {
        preferredLayouts: ['v:v']
      };
    }

    if (manhattanOptions) {
      manhattanOptions = assign(manhattanOptions, hints);
      updatedWaypoints = withoutRedundantPoints(
        repairConnection(
          source, target,
          start, end,
          waypoints,
          manhattanOptions
        )
      );
    }

    return updatedWaypoints || [start, end];
  };

}

PathwaysLayoutHandler.$inject = BaseLayouter.$inject ? [...BaseLayouter.$inject, 'config.verticalLayoutMode'] : ['config.verticalLayoutMode'];
